module.exports = __webpack_public_path__ + "static/tko-46224693e193bedf960e6d554837d15a.jpg";